import { render } from "./HomeJourneyCarousel.vue?vue&type=template&id=0d898404&scoped=true"
import script from "./HomeJourneyCarousel.vue?vue&type=script&lang=js"
export * from "./HomeJourneyCarousel.vue?vue&type=script&lang=js"

import "./HomeJourneyCarousel.vue?vue&type=style&index=0&id=0d898404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d898404"]])

export default __exports__